import { getThumbnailUrl } from "../../utilities/helpers";

const LazyImage = ({ src, alt, style, onClick, thumbnail = true }) => {

  let displaySrc = src;
  if (src && src.includes('eagle.influxeradmin.com')) {
    displaySrc = src.replaceAll('dl=1', 'dl=0');
  }

  const handleClick = onClick ? onClick : () => window.open(displaySrc, '_blank');

  return (
    <img
      loading='lazy'
      alt={alt || src}
      style={style}
      src={thumbnail ? getThumbnailUrl(src) : src}
      onClick={handleClick}
    />
  );
};

export default LazyImage;
